import { useFlag } from '@unleash/proxy-client-react';
import {
  aggregatedDashboardApi,
  DashboardApi,
  legacyDashboardApi,
} from 'config/requests/dashboard';

export function useDashboardApi(): { api: DashboardApi; aggregatedQueryKey: string } {
  const isAggregatedEnabled = useFlag('wppa_12677_aggregated_table_dashboard');
  const aggregatedQueryKey = isAggregatedEnabled ? 'aggregated' : 'legacy';

  return {
    api: isAggregatedEnabled ? aggregatedDashboardApi : legacyDashboardApi,
    aggregatedQueryKey,
  };
}
